"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnchorMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _buttonResetMixin = require("../buttonResetMixin");
var _focusMixin = require("../focusMixin");
var _hoverMediaQueryMixin = require("../hoverMediaQueryMixin");
var _inlineMediaQueryMixin = require("../inlineMediaQueryMixin");
var _spacingMixin = require("../spacingMixin");
var buttonCSS = function buttonCSS(props) {
  if (props.as !== 'button') {
    return '';
  }
  return (0, _buttonResetMixin.buttonResetMixin)(props);
};
var defaultColorCSS = function defaultColorCSS(props) {
  return (0, _styledToken.default)({
    defaultColor: 'Anchor.defaultColor',
    focusColor: 'Anchor.focusColor',
    visitedColor: 'Anchor.visitedColor',
    hoverColor: 'Anchor.hoverColor',
    activeColor: 'Anchor.activeColor'
  }, function (_ref) {
    var defaultColor = _ref.defaultColor,
      focusColor = _ref.focusColor,
      visitedColor = _ref.visitedColor,
      hoverColor = _ref.hoverColor,
      activeColor = _ref.activeColor;
    return (0, _styledComponents.css)(["&{color:", ";}&:focus{color:", ";}&:visited{color:", ";}", ";&:active{color:", ";}"], defaultColor, focusColor, visitedColor, (0, _hoverMediaQueryMixin.hoverMediaQueryMixin)("color: " + hoverColor + ";"), activeColor);
  })(props);
};
var inverseColorCSS = function inverseColorCSS(props) {
  return (0, _styledToken.default)('Anchor.inverseColor', function (inverseColor) {
    return (0, _styledComponents.css)(["&,&:visited,&:active{color:", ";}", ";"], inverseColor, (0, _hoverMediaQueryMixin.hoverMediaQueryMixin)("color: " + inverseColor + ";"));
  })(props);
};
var inverseCSS = function inverseCSS(props) {
  return props.inverse ? inverseColorCSS(props) : defaultColorCSS(props);
};

/** @class AnchorMixin */
/** @method */
var AnchorMixin = function AnchorMixin(props) {
  return (0, _styledToken.default)('Anchor.textDecoration', function (textDecoration) {
    return (0, _styledComponents.css)(["cursor:pointer;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;text-decoration:", ";", " ", " ", " ", ""], textDecoration || 'underline', (0, _focusMixin.focusMixin)(props), (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('inverse', inverseCSS)(props), buttonCSS(props), (0, _spacingMixin.spacingMixin)(props));
  })(props);
};
exports.AnchorMixin = AnchorMixin;